import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
// import DashBoard1 from "views/dashboard/Dashboard1";
import DashBoard from "views/dashboard/Dashboard";

export default class ProtectedRoute extends Component {
	render() {
		return (
			<BrowserRouter>
				<Switch>
					<Route path="/" component={DashBoard} />
				</Switch>
			</BrowserRouter>
		);
	}
}
